// import { Typography } from 'shared/ui/typography';

import { TextCard } from 'shared/ui/cards/textCard';
import { MarginBottom, TablesList } from './styles';
import { Fragment } from 'react/jsx-runtime';
import { FC } from 'react';
import { Appointment } from 'entities/orders';

// import lock from 'assets/icons/lock.svg';
// import { Img } from 'shared/ui/imgStyledComponent';
// import { Flex } from 'shared/ui/flex';
import { Resource } from 'entities/hallmap/model/types';

export const OrderResourcesInfo: FC<{ appointment?: Appointment, conflicts?: Resource[] | null }> = ({
	appointment,
	conflicts,
}) => {
	return (
		<Fragment>
			{appointment?.resources && (
				<MarginBottom $value={16}>
					{/* <Flex $alignItems="center" $justify="row" style={{ marginBottom: '8px' }}>
						<Typography mode="small" style={{ marginRight: '4px' }}>Столы</Typography>
						{appointment.hold_resources && (
							<Img src={lock} $size="verySmall" />
						)}
					</Flex> */}
					<TablesList>
						{appointment?.resources?.map(resource => {
							return (
								<TextCard 
                  key={resource.id} 
                  redBorder={conflicts?.map(resource => resource.name)?.includes(resource.name)} 
                  mode="small"
                  padding='4px 10.5px'
                >
									{resource.name}
								</TextCard>
							);
						})}
					</TablesList>
				</MarginBottom>
			)}
		</Fragment>
	);
};
